'use client';

import React from 'react';
import { ChevronDown } from 'lucide-react';
import LegalDoc from '@/components/LegalDoc';
import { FAQ, OPERATOR } from '@/lib/legal/documents';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Native <details> rather than managed state: it opens without JavaScript,
 * is findable with the browser's own in-page search, and needs no keyboard
 * handling of ours to be reachable.
 */
export default function FaqPage() {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <LegalDoc
      title={isEs ? 'Preguntas frecuentes' : 'Frequently asked questions'}
      intro={
        isEs
          ? 'Lo que la gente pregunta antes de empezar. Si falta la tuya, escríbenos.'
          : 'What people ask before they start. If yours is missing, write to us.'
      }
    >
      {/* No top rule: the section nav above already ends in one, and two
          hairlines a gap apart read as an empty row. */}
      <div className="divide-y divide-hairline border-b border-hairline">
        {FAQ.map((item) => (
          <details key={item.q.en} className="group">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-4 text-[15px] font-medium text-ink [&::-webkit-details-marker]:hidden">
              {isEs ? item.q.es : item.q.en}
              <ChevronDown
                className="h-4 w-4 flex-shrink-0 text-ink-ghost transition-transform duration-200 group-open:rotate-180"
                strokeWidth={2.1}
              />
            </summary>
            <p className="pb-4 pr-8 text-[14.5px] leading-relaxed text-ink-soft">
              {isEs ? item.a.es : item.a.en}
            </p>
          </details>
        ))}
      </div>

      <p className="mt-8 text-[14px] leading-relaxed text-ink-faint">
        {isEs ? '¿Otra pregunta? Escríbenos a ' : 'Another question? Write to us at '}
        <a
          href={`mailto:${OPERATOR.email}`}
          className="font-medium text-brand transition-colors hover:text-brand-bright"
        >
          {OPERATOR.email}
        </a>
        .
      </p>
    </LegalDoc>
  );
}
